/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { accessAPI, Titulo, CampoInformacion, TablaFiltrable } from "../../shared";
import { Card } from "primereact/card";
import { Column } from "primereact/column";

export default function CajaPublica() {
  const { hash } = useParams();
  const navigate = useNavigate();
  const [caja, setCaja] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!hash) return;
    accessAPI(
      "GET",
      `caja/publica/${hash}`,
      null,
      (resp) => setCaja(resp),
      (resp) => setError(resp?.[0]?.msg || "No se pudo cargar la caja"),
    );
  }, [hash]);

  // Fondo violeta acorde al resto de la app pública.
  const fondo = {
    background: "var(--principal)",
    minHeight: "calc(100vh - var(--alturaFooter))",
  };

  if (error) {
    return (
      <div css={fondo}>
        <div css={{ padding: "1.5em", maxWidth: "900px", margin: "0 auto" }}>
          <Card>
            <Titulo>Caja no encontrada</Titulo>
            <p>{error}</p>
          </Card>
        </div>
      </div>
    );
  }

  if (!caja) {
    return (
      <div css={fondo}>
        <div css={{ padding: "1.5em", maxWidth: "900px", margin: "0 auto" }}>
          <Card>
            <p>Cargando…</p>
          </Card>
        </div>
      </div>
    );
  }

  if (caja.estado === "PENDIENTE") {
    return (
      <div css={fondo}>
        <div css={{ padding: "1.5em", maxWidth: "900px", margin: "0 auto" }}>
          <Titulo etiquetas={[{ texto: "Pendiente", neutro: true }]}>
            Caja {caja.numero}
          </Titulo>
          <Card>
            <p>Esta caja todavía no fue registrada.</p>
          </Card>
        </div>
      </div>
    );
  }

  const etiquetaEstado = caja.desactivada
    ? { texto: "Desactivada", error: true }
    : { texto: "Registrada", ok: true };

  const muestras = caja.muestras || [];

  return (
    <div css={fondo}>
      <div css={{ padding: "1.5em", maxWidth: "900px", margin: "0 auto" }}>
        <Titulo etiquetas={[etiquetaEstado]}>Caja {caja.numero}</Titulo>

        <Card>
          <Titulo>Información general</Titulo>
          <div className="grid">
            <CampoInformacion nombreCampo="Descripción">
              {caja.descripcion || "—"}
            </CampoInformacion>
            <CampoInformacion nombreCampo="Ubicación">
              {caja.ubicacion || "—"}
            </CampoInformacion>
            <CampoInformacion nombreCampo="Muestras">
              {muestras.length}
            </CampoInformacion>
          </div>
        </Card>

        <Card css={{ marginTop: "1.5rem" }}>
          <Titulo>Contenido</Titulo>
          <TablaFiltrable conFiltros={false}
            value={muestras}
            emptyMessage="No hay muestras asignadas a esta caja"
            stripedRows
            onRowClick={(e) => navigate(`/m/${e.data.hash}`)}
            css={{ "& .p-datatable-tbody > tr": { cursor: "pointer" } }}
          >
            <Column header="N°" field="numero" />
            <Column
              header="Cliente"
              body={(m) => m.producto?.proceso?.cliente?.razonsocial || "—"}
            />
            <Column header="Producto" field="productoEtiqueta" />
          </TablaFiltrable>
        </Card>
      </div>
    </div>
  );
}
